import useAccountQuery from "@/shared/hooks/useAccountQuery";
import useOrdersSocket from "@/shared/hooks/useOrdersSocket";
import useUserSettingsHook from "@/shared/hooks/useUserSettingsHook";
import { Branch } from "@/shared/utils/interfaces";
import useOrdersQuery from "@/shared/v2/queries/useOrdersQuery";

const Formule = ({ branch }: { branch: Branch }) => {
  const query = useOrdersQuery(undefined, 1, branch);
  useAccountQuery(branch.id);
  useUserSettingsHook(branch.id);
  useOrdersSocket(branch.id, () => query.refetch());

  return <></>;
};

export default Formule;
